import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { CommabreakPipe } from './commabreak.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe, CommabreakPipe],
  imports:[CommonModule],
    exports: [FilterPipe, SearchPipe, ShortNamePipe, CommabreakPipe]
})

export class PipeModule{}
